<template>
	<router-view />
</template>

<script lang="ts" setup>
	import {
		ref,
		watch
	} from "vue";
	import bottomBar from "@/components/bottomBar.vue";
	import {
		useRouter,
		useRoute
	} from "vue-router";

	const router = useRouter();
	const route = useRoute();
	
	document.title = '中概电力科技';

	watch(() => route.path, () => {
		document.body.scrollTop = 0
		document.documentElement.scrollTop = 0
	});
</script>

<style lang="scss">
	/* 设置基础字体大小 */
	html {
		font-size: 16px;
	}

	body {
		margin: 0px;
		padding: 0px;
		overflow-x: hidden;
	}
</style>
